import Alpine, { Alpine as AlpineType } from 'alpinejs';
import Intersect from '@alpinejs/intersect';
import TimeAgo from '@marcreichel/alpine-timeago';
import { de } from 'date-fns/locale';
import MoneyInput from './plugins/MoneyInput';
import Share from './plugins/Share';
import SnapScroll from './plugins/SnapScroll';

declare global {
    interface Window {
        Alpine: AlpineType;
    }
}

window.Alpine = Alpine;

Alpine.store('mainNav', {
    open: false,

    toggle() {
        this.open = !this.open;
    },
});

type FlashMessage = {
    severity: string;
    message: string;
};
type FlashMessagesStore = {
    messages: FlashMessage[];
    // eslint-disable-next-line no-unused-vars
    addMessage: (message: FlashMessage, timeout: number) => void;
    hasMessages: () => boolean;
    hideMessage: () => void;
};

Alpine.store('flashMessages', {
    messages: [],

    addMessage(message: FlashMessage, timeout: number = null) {
        const index = this.messages.push({ ...message, visible: true }) - 1;
        if (timeout) {
            window.setTimeout(() => {
                this.hideMessage(index);
            }, timeout + index * 1000);
        }
    },
    hasMessages() {
        return this.messages.filter(({ visible }) => visible).length > 0;
    },
    hideMessage(index: number) {
        this.messages[index].visible = false;
    },
} as FlashMessagesStore);

document.addEventListener('alpine:init', () => {
    Alpine.data('badgeDate', () => ({
        badgeDate: null,
        init() {
            this.badgeDate = new Date(this.$el.dateTime);
        },
    }));
    Alpine.data('profilePicture', () => {
        return {
            profilePicture: null,
            init() {
                if (document.body.dataset?.isAuthenticated === 'true') {
                    fetch(this.$el.dataset.apiUrl, { credentials: 'same-origin' }).then((response) => {
                        if (response.status === 200) {
                            response.text().then((text) => {
                                this.profilePicture = text;
                            });
                        } else {
                            this.profilePicture = false;
                        }
                    });
                } else {
                    this.profilePicture = false;
                }
            },
        };
    });

    // TODO: Replace this hack with a proper implementation :)
    const flashMessagesCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith('flashmessages='))
        ?.split('=')[1];
    if (flashMessagesCookie) {
        JSON.parse(decodeURIComponent(flashMessagesCookie)).forEach((flashMessage) => {
            const flashMessageStore = Alpine.store('flashMessages') as FlashMessagesStore;
            flashMessageStore.addMessage(
                {
                    severity: flashMessage.severity.toLowerCase(),
                    message: flashMessage.message.replaceAll('+', ' '),
                },
                8000
            );
        });
        document.cookie = 'flashmessages=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;';
    }
});

Alpine.plugin(Intersect);
Alpine.plugin(MoneyInput);
Alpine.plugin(Share);
Alpine.plugin(SnapScroll);

Alpine.plugin(
    TimeAgo.configure({
        locale: de,
    })
);

Alpine.start();
